var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMemoryStrengthPartial(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4787"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 2994",
    fill: "none",
    d: "M0 0h40v40H0z"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4774"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4387"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2160",
    d: "M14.311 29.88l3.581-8.354a.664.664 0 00-.609-.924h-2.618a.662.662 0 01-.61-.925l4.056-9.279a.663.663 0 01.607-.4h6.8a.663.663 0 01.517 1.077l-3.57 4.476a.663.663 0 00.518 1.076h2.982a.663.663 0 01.47 1.135z",
    fill: "#575757",
    stroke: "#575757",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }))))));
}
export default SvgIconMemoryStrengthPartial;